<script lang="ts">
  import { productCategoryMapping } from "$lib/types/products";
  interface Props {
    filters?: string[];
    activeFilter?: string;
    search?: string;
    class?: string;
  }

  let { filters = [], activeFilter = "", search = "", class: classes = "" }: Props = $props();
</script>

<p class="my-2 mb-2 sr-only"><strong>Filter produkter:</strong></p>

<ul class="list-none flex gap-y-2 gap-x-3 laptop:gap-x-4 desktop:gap-x-6 p-0 mt-0 {classes}">
  <li>
    <a
      data-sveltekit-noscroll
      class="button button-link px-0"
      class:button-selected={activeFilter === "nettbutikk"}
      href={`/nettbutikk${search}`}
      rel={search ? "nofollow" : undefined}
    >
      Alle produkter
    </a>
  </li>

  {#each filters as filter (filter)}
    <li>
      <a
        data-sveltekit-noscroll
        class="button button-link px-0 capitalize"
        class:button-selected={filter === activeFilter}
        href={`/nettbutikk/kategori/${filter}${search}`}
        rel={search ? "nofollow" : undefined}
      >
        {productCategoryMapping.find((a) => a.key === filter)?.value || filter}
      </a>
    </li>
  {/each}
</ul>

<style lang="postcss">
  a {
    white-space: nowrap;
    text-decoration-line: underline;
  }
</style>
